import 'Assets/styles/default/pages/viewRedemption/ViewRedemptionStyles.less';
import React, { useEffect, useState } from 'react';
import { Col, Row } from 'antd';
import {
  Spin,
  Table,
  Typography,
  VertContainer,
  VertIcon,
  VertRadio,
  VertTypography,
} from '@vertem-core/vertice-ds';
import PropTypes from 'prop-types';
import { formatToString } from 'Utils/format';
import { BsFiletypePdf } from 'react-icons/bs';
import { cnpj } from 'cpf-cnpj-validator';
import { useMediaQuery } from 'react-responsive';
import { calculatePriceForPoint } from 'Utils/calculatePriceForPoint';
import { convertPoints } from 'Utils/maskFormat';
import { useSelector } from 'react-redux';

const SpotOrcament = ({
  spot,
  callModalDocuments,
  isPMO,
  isLead,
  quote,
  setQuote,
  productsIds,
  setProductsIds,
}) => {
  const userProfile = useSelector((state) => state.oidc.user.profile);
  const userInfos = useSelector(({ oidc: data }) => data);

  const {
    user: { profile, access_token },
  } = userInfos;
  const username = profile.username || profile['custom:login'];

  const config = {
    campaignId: userProfile['custom:campaign_id'],
    catalogId: userProfile['custom:catalog_id'],
    participantId: userProfile['custom:participant_id'],
    Authorization: `Bearer ${access_token}`,
    username: username,
  };
  const [quotes, setQuotes] = useState(spot?.files);

  const [productsTotalPrice, setProductsTotalPrice] = useState(0);
  const mediaQuery = useMediaQuery({ query: '(max-width: 768px)' });
  const [totalPoints, setTotalPoints] = useState(0);
  const [loadingQuote, setLoadingQuote] = useState(true);

  const [products, setProducts] = useState([]);
  const [customProducts, setCustomProducts] = useState([]);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);

  useEffect(() => {
    if (spot.products.length > 0) {
      updateProductsList(spot.products, quote);
    }
  }, [spot.products, quote]);

  useEffect(() => {
    if (products.length > 0) updateProductsList(products, null);
  }, [quote]);

  useEffect(() => {
    if (spot.files.length > 0) {
      setLoadingQuote(false);
      setQuotes(spot.files);
    }
  }, [spot.files]);

  const findProductQuote = (productId, listQuotes = quotes) => {
    const _quote =
      quote !== null &&
      quote !== undefined &&
      listQuotes !== undefined &&
      listQuotes.length > 0 &&
      listQuotes.find((q) => q.id === quote?.id);

    if (
      _quote?.products &&
      _quote?.products?.length > 0 &&
      _quote?.products?.find((p) => p.productId === productId)
    ) {
      return _quote?.products?.find((p) => p.productId === productId);
    }
    return null;
  };

  const handleSetProductsIds = (isChecked, productId) => {
    let newProductsIds = productsIds;
    if (isChecked) {
      newProductsIds = productsIds.filter((x) => x !== productId);
    } else {
      newProductsIds.push(productId);
    }

    let newProducts = products.map((product) =>
      product.id === productId
        ? { ...product, isChecked: isChecked ? false : true }
        : { ...product }
    );

    setProductsIds(newProductsIds);
    setProducts(newProducts);
  };

  const onSelectChange = (selectedRowKeys) => {
    setProductsIds(selectedRowKeys);
    setSelectedRowKeys(selectedRowKeys);

    let newProducts = products.map((product) =>
      selectedRowKeys.includes(product.id)
        ? { ...product, isChecked: true }
        : { ...product, isChecked: false }
    );

    updateTotalValue(newProducts);
  };

  const updateProductsList = (data, listQuotes = null) => {
    let list = [];
    if (data.length > 0) {
      data
        .map((product) => {
          let findProduct =
            quote !== null ? findProductQuote(product.id) : null;
          if (listQuotes !== null) {
            const produtQuote = listQuotes.products.find(
              (p) => p.productId === product.id
            );
            findProduct = produtQuote || null;
          }

          if (findProduct !== null) {
            handleSetProductsIds(false, product.id);
          }
          list.push({
            ...product,
            isChecked: findProduct !== null,
            unitPrice: findProduct !== null ? findProduct.unitPrice : 0,
            total: findProduct !== null ? findProduct.unitPointsPrice : 0,
          });
        })
        .flat(1);
    }
    setProducts(list);

    if (listQuotes !== null) updateTotalValue(list);
  };

  const updateTotalValue = async (data) => {
    if (data.length > 0) {
      if (spot.redemptionStatusId === 3) {
        data = data.filter((item) => item.approved === true);
      }

      const totalPrice = data.reduce((accumulator, p) => {
        return p.isChecked
          ? accumulator + p.unitPrice * p.quantity
          : accumulator + 0;
      }, 0);

      const totalPoints = await calculatePriceForPoint(totalPrice, config);
      setProductsTotalPrice(totalPrice);
      setTotalPoints(totalPoints);
    } else {
      setProductsTotalPrice(0);
    }
  };

  const showTotalValue = () => {
    if (productsTotalPrice > 0) {
      return (
        <>
          {`Orçado: ${formatToString(productsTotalPrice, 'currency')} /  
          
          ${convertPoints(totalPoints)} pontos`}
          <br />
        </>
      );
    } else {
      return (
        <>
          {`Solicitado: ${formatToString(
            spot !== null ? spot.totalPrice : 0,
            'currency'
          )}`}
          <br />
          {spot !== null && spot.redemptionStatusId !== 1
            ? formatToString(spot.totalPoints) + ' pontos'
            : ''}
        </>
      );
    }
  };
  const handleChangeOrcament = (e) => {
    let _quote = quotes.filter((x) => x.id === e.target.value);

    setProductsIds([]);
    setQuote(_quote[0]);
  };

  let rowSelection = {
    selectedRowKeys: selectedRowKeys,
    onChange: onSelectChange,
    hideSelectAll: true,
  };

  const columns = [
    {
      title: 'Produto',
      dataIndex: 'name',
      key: 'name',
      sorter: (a, b) => a.name.length - b.name.length,
      showSorterTooltip: false,
      render: (name, product) => {
        return (
          <div className="container-details-view-redemption">
            <Typography.Text className="font-weight-700">
              {name}
            </Typography.Text>
            <Typography.Text>{product.description}</Typography.Text>
          </div>
        );
      },
    },
    {
      title: 'Valor solicitado',
      dataIndex: 'unitPrice',
      key: 'unitPrice',
      sorter: (a, b) => a.unitPrice - b.unitPrice,
      showSorterTooltip: false,
      render: (unitPrice, product) => (
        <div>
          {unitPrice === 0 ? (
            '-'
          ) : (
            <>
              {formatToString(unitPrice, 'currency')} <br />
              {unitPrice === 0
                ? '0 pontos'
                : `${formatToString(product.unitPointsPrice)} pontos`}
            </>
          )}
        </div>
      ),
    },

    {
      title: 'Quantidade',
      dataIndex: 'quantity',
      key: 'quantity',
      sorter: (a, b) => a.quantity - b.quantity,
      showSorterTooltip: false,
    },
    {
      title: 'Valor total',
      dataIndex: 'total',
      key: 'total',
      sorter: (a, b) => a.total - b.total,
      showSorterTooltip: false,
      render: (total, product) => (
        <div>
          {formatToString(total, 'currency')} <br />
          {formatToString(product.unitPointsPrice * product.quantity) +
            ' pontos'}
        </div>
      ),
    },
  ];

  const productsData = () => {
    const dataProducts = products.map((product) => {
      const productQuote = findProductQuote(product.id);

      let unitPriceQuote = productQuote !== null ? productQuote.unitPrice : 0;
      let unitPointsPrice =
        productQuote !== null ? productQuote.unitPointsPrice : 0;
      const isChecked = productQuote !== null;

      let calculatedUnitPrice =
        spot.redemptionStatusId === 3 && !product.approved
          ? 0
          : product.unitPrice;

      let productClone = {
        ...product,
        unitPrice: calculatedUnitPrice,
      };

      return {
        key: product.id,
        ...productClone,
        unitPriceQuote,
        total: unitPriceQuote * product.quantity,
        unitPointsPrice,
        isChecked: isChecked,
      };
    });

    let keyMap = dataProducts
      .filter((item) => item.isChecked === true)
      .map((item) => item.key);

    setSelectedRowKeys(keyMap);
    setProductsIds(keyMap);

    setCustomProducts(dataProducts);
  };

  useEffect(() => {
    if (products.length > 0) {
      productsData();
    }
  }, [products]);

  const filter =
    quotes !== null ? quotes.filter((files) => files.type === 1 && files) : [];

  return (
    <>
      {filter !== null && filter.length > 0 && (
        <>
          {spot && spot.redemptionStatusId >= 2 && (
            <>
              <VertContainer className="container-subtitle-view-redemption">
                <VertIcon
                  size="large"
                  className="spacing-icon"
                  isVertice
                  iconName="List"
                />
                <Typography.Text className="subtitle-view-redemption">
                  Orçamento
                </Typography.Text>
              </VertContainer>

              <Row
                className="container-summary-view-redemption"
                gutter={[32, 32]}
              >
                <Col xs={24} sm={12}>
                  <VertContainer className="container-details-view-redemption">
                    <Typography.Text className="text-view-redemption font-weight-700">
                      Orçamento
                    </Typography.Text>
                    <Typography.Text className="text-view-redemption">
                      {!spot.sendToOperation ? (
                        <Typography.Text>
                          Sem cotação da Premmiar
                        </Typography.Text>
                      ) : (
                        <>
                          {!isLead && spot.redemptionId === 2 && (
                            <Typography.Text>
                              Escolha o orçamento de sua preferência (somente
                              um).
                            </Typography.Text>
                          )}
                        </>
                      )}
                    </Typography.Text>
                    {loadingQuote ? (
                      <Spin />
                    ) : quotes.length > 0 &&
                      quotes !== null &&
                      spot.redemptionStatusId > 1 ? (
                      <VertRadio.Group
                        onChange={(e) => {
                          handleChangeOrcament(e);
                        }}
                        value={quote?.id}
                      >
                        {quotes
                          .filter((x) => x.type === 1)
                          .map((item) => {
                            const show =
                              (isPMO &&
                                isLead &&
                                spot.redemptionStatusId === 1) ||
                              spot.redemptionStatusId === 2 ||
                              (spot.redemptionStatusId > 2 && item.approved) ||
                              (spot.redemptionStatusId === 4 &&
                                spot.type === 4);
                            return (
                              show && (
                                <>
                                  <Row
                                    gutter={[32, 32]}
                                    justify="space-between"
                                  >
                                    <Col span={18}>
                                      {(isPMO &&
                                        spot.redemptionStatusId === 2) ||
                                        (spot.redemptionStatusId === 4 &&
                                          spot.type === 4) ? (
                                        <VertRadio
                                          key={`supplier-${item.id}`}
                                          checked={
                                            quote?.id === item.id ? true : false
                                          }
                                          value={item.id}
                                        />
                                      ) : (
                                        <VertTypography.Text className="font-weight-700">
                                          {'-  '}
                                        </VertTypography.Text>
                                      )}

                                      <Typography.Text className="font-weight-700">
                                        {item.supplier.companyName} -{' '}
                                        {cnpj.format(item.supplier.document)}
                                      </Typography.Text>
                                    </Col>
                                    <Col span={6}>
                                      {mediaQuery ? (
                                        <Typography.Text className="text-view-redemption">
                                          <a
                                            className="link-view-redemption"
                                            onClick={() =>
                                              callModalDocuments(1, item.url)
                                            }
                                            target="_blank"
                                          >
                                            Ver Cotação
                                          </a>
                                        </Typography.Text>
                                      ) : (
                                        <a
                                          href={item.url}
                                          target="_blank"
                                          rel="noopener noreferrer"
                                        >
                                          <BsFiletypePdf className="icon-pdf-orcament" />
                                        </a>
                                      )}
                                    </Col>
                                  </Row>
                                </>
                              )
                            );
                          })}
                      </VertRadio.Group>
                    ) : (
                      <Row
                        className="container-summary-view-redemption"
                        gutter={[32, 32]}
                      >
                        <Typography.Text>
                          Ainda não há orçamentos a serem aprovados.
                        </Typography.Text>
                      </Row>
                    )}
                  </VertContainer>
                </Col>
              </Row>
            </>
          )}
        </>
      )}
      <VertContainer className="container-subtitle-view-redemption">
        <VertIcon
          size="large"
          className="spacing-icon"
          isVertice
          iconName="Shop"
        />
        <Typography.Text className="subtitle-view-redemption">
          Produtos
        </Typography.Text>
      </VertContainer>
      <VertContainer>
        <Table
          rowSelection={spot.redemptionStatusId === 2 ? rowSelection : null}
          pagination={false}
          size="small"
          bordered
          columns={columns}
          rowClassName={(record, index) => {
            const product = products[index] || customProducts[index];
            const productQuote = findProductQuote(product.id);

            let blockedText =
              productQuote !== null || spot.redemptionStatusId === 1
                ? ''
                : 'blocked-text';

            if (spot.redemptionStatusId > 2 && spot.type !== 4) {
              blockedText = product.approved ? '' : 'blocked-text';
            }

            return blockedText;
          }}
          dataSource={customProducts}
        />

        <VertContainer className="container-total-value">
          <Row>
            <Col xs={12} sm={12} md={6} lg={12} xl={12} xxl={12}>
              <VertContainer>
                <Typography.Text className="text-total-value">
                  VALOR TOTAL
                </Typography.Text>
              </VertContainer>
            </Col>

            <Col xs={12} sm={12} md={18} lg={12} xl={12} xxl={12}>
              <VertContainer className="col-total-value">
                <Typography.Text className="text-total-value">
                  {showTotalValue()}
                </Typography.Text>
              </VertContainer>
            </Col>
          </Row>
        </VertContainer>
      </VertContainer>
    </>
  );
};

SpotOrcament.propTypes = {
  spot: PropTypes.object.isRequired,
  callModalDocuments: PropTypes.func,
  isPMO: PropTypes.bool,
  isLead: PropTypes.bool,
};

export default SpotOrcament;
